module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_14.c71f5c49.jpg";